import { api, ApiError } from "@risalabs_frontend_org/api-client";
import { API_ENDPOINTS } from "../../../../enums/apiUrls";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";

export interface UploadBatchReceipt {
  filename: string;
  row_count: number;
  status: "accepted";
  rpa_list: ["oncoemr", "cmm"];
}

/** Upload and ingest before the server schedules the OncoEMR and CMM pipeline. */
export const onSaveStatFile = async (
  uploadedFile: File,
  nonEpaRequired: boolean,
): Promise<UploadBatchReceipt> => {
  const orgId = getOrgIdForFetchExternalWorklist();
  if (!orgId) throw new Error("Select a facility before uploading.");
  const form = new FormData();
  form.append("file", uploadedFile);
  form.append("org_id", orgId);
  form.append("non_epa_required", String(nonEpaRequired));
  try {
    return await api.post<FormData, UploadBatchReceipt>(
      API_ENDPOINTS.UPLOAD_ONCOEMR_BATCH,
      form,
    );
  } catch (error) {
    if (error instanceof ApiError) {
      const detail = (error.body as { detail?: unknown })?.detail;
      if (typeof detail === "string") throw new Error(detail);
      if (error.status === 404)
        throw new Error("Upload & run is not available on this server yet.");
    }
    throw new Error(
      "Could not confirm the upload. Check Delivery before retrying with the same filename.",
    );
  }
};
